export interface PollingCacheEntry<Result = unknown> {
  task_id: string;
  status: 'running' | 'success' | 'failure';
  result?: Result;
  created_at: number;
  expires_at: number;
}

function stableHash(params: Record<string, unknown>): string {
  const sorted = Object.keys(params)
    .sort()
    .reduce((acc, key) => {
      acc[key] = params[key];
      return acc;
    }, {} as Record<string, unknown>);
  const str = JSON.stringify(sorted);
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash) + str.charCodeAt(i);
  }
  return (hash >>> 0).toString(36);
}

export function buildCacheKey(component: string, userId: string, params: Record<string, unknown>): string {
  return `mpc_polling__${userId}__${component}__${stableHash(params)}`;
}

export function readCache<R>(key: string): PollingCacheEntry<R> | null {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    return JSON.parse(raw) as PollingCacheEntry<R>;
  } catch {
    return null;
  }
}

export function writeCache<R>(key: string, entry: PollingCacheEntry<R>): void {
  try {
    localStorage.setItem(key, JSON.stringify(entry));
  } catch {
    // localStorage unavailable (e.g. Safari private mode) — degrade silently
  }
}

export function clearCache(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
}
